import FrontendWebPad from '../../types/FrontendWebPad'
import axios from '../axios'
import { API_BASE_URL } from '../constants'

interface PadUpdateBody {
  soundFileUuid: string

  name: string
  color: string
  loop: boolean
  multishot: boolean
  alwaysPlayFromStart: boolean
  volume: number
  startTime: number | string | null
  endTime: number | string | null
  midiBinding: string // Assuming it is a string, can be another type like number or object depending on the use case
  shortcut: string
  sortIndex: number

  fadeOutDuration: number | null
  fadeOutOnPressDuration: number | null
  autoFadeInDuration: number | null
  fadeInOnPressDuration: number | null
  coverImageFile?: File
  clearImage?: boolean
}

const updatePad = async (
  padUuid: string,
  body: Partial<PadUpdateBody>,
): Promise<FrontendWebPad> => {
  const formData = new FormData()
  // formData.append('fileSizeBytes', String(fileSizeBytes || 0))

  if (body.coverImageFile) {
    formData.append('coverImage', body.coverImageFile, body.coverImageFile.name)
  }

  const appendIfDefined = (
    key: string,
    value?: string | boolean | number | null,
  ) => {
    if (!key || value === undefined || value === null) return
    if (typeof value === 'string') formData.append(key, String(value || ''))
    if (typeof value === 'number') formData.append(key, String(value || 0))
    if (typeof value === 'boolean') formData.append(key, String(value))
  }

  appendIfDefined('soundFileUuid', body.soundFileUuid)
  appendIfDefined('name', body.name)
  appendIfDefined('color', body.color)
  appendIfDefined('loop', body.loop)
  appendIfDefined('multishot', body.multishot)
  appendIfDefined('alwaysPlayFromStart', body.alwaysPlayFromStart)
  appendIfDefined('volume', body.volume)
  appendIfDefined('startTime', body.startTime)
  appendIfDefined('endTime', body.endTime)
  appendIfDefined('midiBinding', body.midiBinding)
  appendIfDefined('shortcut', body.shortcut)
  appendIfDefined('sortIndex', body.sortIndex)
  appendIfDefined('fadeOutDuration', body.fadeOutDuration)
  appendIfDefined('fadeOutOnPressDuration', body.fadeOutOnPressDuration)
  appendIfDefined('autoFadeInDuration', body.autoFadeInDuration)
  appendIfDefined('fadeInOnPressDuration', body.fadeInOnPressDuration)
  appendIfDefined('clearImage', body.clearImage)

  const response = await axios.patch(
    `${API_BASE_URL}/pads/${padUuid}`,
    formData,
  )

  return response.data
}

export default updatePad
